import { api } from './api';

export const collectionApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getCollection: builder.mutation({
      query: ({
        order,
        orderBy,
        filter,
        collectionId,
        collectionIndex,
        dateRange,
      }) => {
        const url = 'getCollection';
        return {
          url,
          method: 'POST',
          body: {
            order,
            orderBy,
            filter,
            collectionId,
            collectionIndex,
            dateRange,
          },
        };
      },
    }),

    saveCollection: builder.mutation({
      query: (collectionData) => {
        return {
          url: 'saveCollection',
          method: 'POST',
          body: collectionData,
        };
      },
    }),

    deleteCollection: builder.mutation({
      query: ({
        order,
        orderBy,
        filter,
        page,
        pageSize,

        collectionId,
      }) => {
        return {
          url: 'deleteCollection',
          method: 'POST',
          body: {
            order,
            orderBy,
            filter,
            page,
            pageSize,

            collectionId,
          },
        };
      },
    }),

    getCollections: builder.query({
      query: ({
        order,
        orderBy,
        filter,
        page,
        pageSize,
        dateRange,
      }) => {
        return {
          url: 'getCollections',
          method: 'POST',
          body: {
            order,
            orderBy,
            filter,
            page,
            pageSize,
            dateRange,
          },
        };
      },
    }),

    getCollectionsForUser: builder.mutation<unknown, { all?: boolean } | void>({
      query: ({
        all,
      } = {}) => {
        return {
          url: `getCollectionsForUser?all=${all ? 1 : ''}`,
        };
      },
    }),
  }),
});

export const {
  useGetCollectionMutation,
  useSaveCollectionMutation,
  useDeleteCollectionMutation,
  useGetCollectionsQuery,
  useGetCollectionsForUserMutation,
} = collectionApi;
